import { Stack, Text } from '@chakra-ui/react';
import { NumberFormatType, NumberFormatConfigs } from '../../../../sheet/types';
import {
  CurrenciesMenu,
  CustomFormatInput,
  DateFormatMenu,
  DecimalPlacesInput,
  DurationFormatMenu,
  FractionFormatMenu,
  NegativeNumberFormat,
  ThousandSeparatorCheckbox,
  TimeFormatMenu,
} from './ConfigurationsViews';
import { FormikProps } from 'formik';
import { StackProps } from '@chakra-ui/react';

interface NumberFormatConfigurationsProps {
  formik: FormikProps<NumberFormatConfigs>;
}

const stackProps: Partial<StackProps> = {
  spacing: 4,
  width: '80%',
};

const NumberTypeConfigs = ({ formik }: NumberFormatConfigurationsProps) => {
  return (
    <Stack {...stackProps}>
      <NegativeNumberFormat
        value={formik.values.negativeFormat}
        setFieldValue={formik.setFieldValue}
      />
      <ThousandSeparatorCheckbox
        value={formik.values.showThousandSeparator}
        setFieldValue={formik.setFieldValue}
      />
      <DecimalPlacesInput
        value={formik.values.decimalPlaces}
        setFieldValue={formik.setFieldValue}
      />
    </Stack>
  );
};
const PercentTypeConfigs = ({ formik }: NumberFormatConfigurationsProps) => {
  return (
    <Stack {...stackProps}>
      <DecimalPlacesInput
        value={formik.values.decimalPlaces}
        setFieldValue={formik.setFieldValue}
      />
    </Stack>
  );
};
const CurrencyTypeConfigs = ({ formik }: NumberFormatConfigurationsProps) => {
  return (
    <Stack {...stackProps}>
      <CurrenciesMenu
        code={formik.values.currencyCode}
        onChange={formik.setFieldValue}
      />
      <NegativeNumberFormat
        value={formik.values.negativeFormat}
        setFieldValue={formik.setFieldValue}
      />
      <ThousandSeparatorCheckbox
        value={formik.values.showThousandSeparator}
        setFieldValue={formik.setFieldValue}
      />
      <DecimalPlacesInput
        value={formik.values.decimalPlaces}
        setFieldValue={formik.setFieldValue}
      />
    </Stack>
  );
};

const AccountingTypeConfigs = ({ formik }: NumberFormatConfigurationsProps) => {
  return (
    <Stack {...stackProps}>
      <CurrenciesMenu
        includeNone
        code={formik.values.currencyCode}
        onChange={formik.setFieldValue}
      />
      <ThousandSeparatorCheckbox
        value={formik.values.showThousandSeparator}
        setFieldValue={formik.setFieldValue}
      />
      <DecimalPlacesInput
        value={formik.values.decimalPlaces}
        setFieldValue={formik.setFieldValue}
      />
    </Stack>
  );
};

const DateAndTimeTypeConfigs = ({
  formik,
}: NumberFormatConfigurationsProps) => (
  <Stack {...stackProps}>
    <DateFormatMenu
      value={formik.values.dateFormat}
      setFieldValue={formik.setFieldValue}
    />
    <TimeFormatMenu
      value={formik.values.timeFormat}
      setFieldValue={formik.setFieldValue}
    />
  </Stack>
);

const DurationTypeConfigs = ({ formik }: NumberFormatConfigurationsProps) => (
  <Stack {...stackProps}>
    <DurationFormatMenu
      value={formik.values.durationFormat}
      setFieldValue={formik.setFieldValue}
    />
  </Stack>
);

const ScientificTypeConfigs = ({ formik }: NumberFormatConfigurationsProps) => {
  return (
    <Stack {...stackProps}>
      <DecimalPlacesInput
        value={formik.values.decimalPlaces}
        setFieldValue={formik.setFieldValue}
      />
    </Stack>
  );
};

const FractionTypeConfigs = ({ formik }: NumberFormatConfigurationsProps) => (
  <Stack {...stackProps}>
    <FractionFormatMenu
      value={formik.values.fractionFormat}
      setFieldValue={formik.setFieldValue}
    />
  </Stack>
);

const CustomTypeConfigs = ({ formik }: NumberFormatConfigurationsProps) => (
  <Stack {...stackProps}>
    <CustomFormatInput
      value={formik.values.customCode}
      setFieldValue={formik.setFieldValue}
    />
  </Stack>
);

export const NumberFormatConfigurations: React.FC<
  NumberFormatConfigurationsProps
> = ({ formik }) => {
  switch (formik.values.type) {
    case NumberFormatType.Automatic:
      return <Text>Format will be applied automatically</Text>;
    case NumberFormatType.Text:
      return (
        <Text>
          All type of content including numbers, will be treated as text and
          displayed exactly as entered.
        </Text>
      );
    case NumberFormatType.Number:
      return <NumberTypeConfigs formik={formik} />;
    case NumberFormatType.Percent:
      return <PercentTypeConfigs formik={formik} />;
    case NumberFormatType.Currency:
      return <CurrencyTypeConfigs formik={formik} />;
    case NumberFormatType.Accounting:
      return <AccountingTypeConfigs formik={formik} />;
    case NumberFormatType.Fraction:
      return <FractionTypeConfigs formik={formik} />;
    case NumberFormatType.Scientific:
      return <ScientificTypeConfigs formik={formik} />;
    case NumberFormatType.DateNTime:
      return <DateAndTimeTypeConfigs formik={formik} />;
    case NumberFormatType.Duration:
      return <DurationTypeConfigs formik={formik} />;
    case NumberFormatType.Custom:
      return <CustomTypeConfigs formik={formik} />;
    default:
      return <div></div>;
  }
};

export default NumberFormatConfigurations;
